import { render } from "./WideScreenLayout.vue?vue&type=template&id=7389b396"
import script from "./WideScreenLayout.vue?vue&type=script&lang=js"
export * from "./WideScreenLayout.vue?vue&type=script&lang=js"

import "./WideScreenLayout.vue?vue&type=style&index=0&id=7389b396&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__